import keyMirror from 'keymirror';

export const stickersOnboardingActionTypes = keyMirror({
	SEND_STICKERS_ONBOARDED_REQUEST: null,
	SEND_STICKERS_ONBOARDED_SUCCESS: null,
	SEND_STICKERS_ONBOARDED_ERROR: null,
});
